import PropTypes from 'prop-types';

/* PropTypes */

export const NotificationsDeferPopupProptypes = {
  jobId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  onClose: PropTypes.func.isRequired,
  setDeferredNotifications: PropTypes.func,
};
